import "./style.css"

const platform = /Mac|iPhone|iPad/.test(navigator.platform)
  ? "darwin"
  : /Win/.test(navigator.platform)
    ? "win32"
    : "linux"

Object.defineProperty(globalThis, "process", {
  configurable: true,
  value: {
    env: {},
    nextTick(callback: () => void) {
      queueMicrotask(callback)
    },
    platform,
  },
})

const internal = new URL(location.href).searchParams.get("__opencode_internal")
const start =
  import.meta.env.VITE_OPENCODE_WASI_SMOKE_TEST === "1" && internal === "wasi-smoke"
    ? startWasiSmokeTest()
    : import("./mount")

void start.catch((cause) => {
  const error = cause instanceof Error ? cause : new Error(String(cause))
  document.documentElement.dataset.opencodeRuntime = "failed"
  const root = document.getElementById("opencode")
  if (root) root.textContent = `OpenCode failed to start: ${error.message}`
  console.error(error)
})

async function startWasiSmokeTest() {
  const { installWasiSmokeTestEntry } = await import("./runtime/wasi-test-entry")
  installWasiSmokeTestEntry()
  document.documentElement.dataset.opencodeRuntime = "ready"
}
